'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tinymceReact = require('@tinymce/tinymce-react');
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var TinyMCEEditor = function (props) {
    var title = props.title, handleChange = props.handleChange, _a = props.initialValue, initialValue = _a === void 0 ? '' : _a, _b = props.height, height = _b === void 0 ? 500 : _b, tinymceScriptSrc = props.tinymceScriptSrc;
    return (React__default.createElement(styledComponents.StyledDiv, null,
        title && React__default.createElement(styledComponents.StyledInputLabel, null, title),
        React__default.createElement(styledComponents.GlobalStyle, null),
        React__default.createElement(tinymceReact.Editor, { tinymceScriptSrc: tinymceScriptSrc, initialValue: initialValue, init: utils.getInitConfig(height), onEditorChange: handleChange })));
};

module.exports = TinyMCEEditor;
